import { Link } from "react-router-dom";
import AppleKpi from "./AppleKpi";

/**
 * StatCard — Apple-privacy style KPI card used across all admin, secretary and
 * pharmacy dashboards. Thin wrapper over `AppleKpi` that preserves navigation
 * (`to`) and the historical API (`title`, `value`, `unit`, `subtitle`).
 */
export default function StatCard({
  title,
  value,
  unit,
  subtitle,
  to,
  // legacy props — kept for API compat, no visual effect
  active: _active,
  accent: _accent,
  icon,
  description,
  label,
  testid,
}) {
  const displayValue =
    unit !== undefined && unit !== null && unit !== ""
      ? `${value}${unit.startsWith("/") ? "" : " "}${unit}`
      : value;

  const card = (
    <AppleKpi
      icon={icon}
      title={title}
      description={description}
      label={label}
      value={displayValue}
      footer={subtitle}
      testid={testid}
    />
  );

  if (to) {
    return (
      <Link
        to={to}
        className="block group outline-none focus-visible:ring-2 focus-visible:ring-[#0071E3] rounded-[22px] transition active:scale-[0.995]"
      >
        {card}
      </Link>
    );
  }
  return card;
}
